// src/EURegulation.tsx
import { Badge, Text } from "@chakra-ui/react";
import { EuropeUnion } from "@airhelp/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var EURegulation = ({ text, ...props }) => /* @__PURE__ */ jsxs(Badge, {
  display: "flex",
  alignItems: "center",
  ...props,
  children: [
    /* @__PURE__ */ jsx(EuropeUnion, {
      mr: 2,
      boxSize: 6
    }),
    /* @__PURE__ */ jsx(Text, {
      fontSize: "sm",
      fontWeight: "bold",
      color: "primary.500",
      children: text
    })
  ]
});

export {
  EURegulation
};
